import { useEffect, useState } from "react";
import Paragraph from "../Paragraph/Paragraph";
import List from "../List/List";
import Table, { RRZJTable } from "../Table/Table";
import { createSlug, nextVideo, previousVideo } from "../../utils/utils";
import { useLocation } from "react-router-dom";

import classes from "./VideoTextContainer.module.css";
import clsx from "clsx";
import YoutubePlayer from "../VideoCard/YoutubePlayer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import ListItem from "../ListItem/ListItem";
import ImageModal from "../ImageModal/ImageModal";
import DescriptionTableA from "../Table/DescriptionsTableA";
import DescriptionTableB from "../Table/DescriptionsTableB";

import SinglePDF from "../PDF/SinglePDF";
import { pdfjs } from "react-pdf";
import pdf from "../../assets/TvaryRuky.pdf";
pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface VideoTextContainerInterface {
  url: string;
  setUrl: any;
  onParagraphClick: any;
  noVideo: boolean;
  chapterContent: any;
  urlArray: string[];
  urlIndex: number;
  setUrlIndex: any;
  playing: boolean;
  setPlaying: any;
  foldableTables?: boolean;
  english?: boolean;
}

const VideoTextContainer = ({
  chapterContent,
  url,
  setUrl,
  onParagraphClick,
  noVideo,
  urlArray,
  urlIndex,
  setUrlIndex,
  playing,
  setPlaying,
  foldableTables,
  english,
}: VideoTextContainerInterface) => {
  const location = useLocation();

  /* update URL when urlIndex changes */
  useEffect(() => {
    setUrl(urlArray[urlIndex]);
  }, [setUrl, urlIndex, urlArray]);

  const createHeadline = (headline: string, number?: string) => {
    if (number) {
      return { __html: number.concat(" ").concat(headline) };
    } else {
      return { __html: headline };
    }
  };

  const itemToSubchapter = (item: any) => (
    <div id={item.number + ". " + item.headline}>
      <h2
        dangerouslySetInnerHTML={createHeadline(item.headline, item.number)}
        id={createSlug(item.number + " " + item.headline)}
        className={classes.clickable}
        style={{
          backgroundColor: item.headline_url === url ? "white" : undefined,
        }}
        onClick={() => onParagraphClick(item.headline_url)}
      />
      <div className={classes.textWrapper}>
        <div className={classes.paragraph}>
          {item.pars && item.pars.map(createContent)}
        </div>
      </div>
    </div>
  );

  const createContent = (innerItem: any) => {
    if (innerItem.type === "paragraph") {
      return (
        <Paragraph
          item={innerItem}
          notClickable={noVideo}
          onParagraphClick={onParagraphClick}
          url={url}
        />
      );
    } else if (innerItem.type === "table") {
      return (
        <Table
          url={url}
          item={innerItem}
          onParagraphClick={onParagraphClick}
          classes={classes}
          foldable={foldableTables}
        />
      );
    } else if (innerItem.type === "image") {
      return (
        <ImageModal
          path={innerItem.path}
          alt={innerItem.alt}
          url={innerItem.url}
          currentUrl={url}
          onParagraphClick={onParagraphClick}
        />
      );
    } else if (innerItem.type === "list") {
      return (
        <List
          noVideo={noVideo}
          onParagraphClick={onParagraphClick}
          url={url}
          list={innerItem}
        />
      );
    } else if (innerItem.type === "special RRZJ table") {
      return (
        <RRZJTable
          url={url}
          data={innerItem}
          onParagraphClick={onParagraphClick}
          classes={classes}
          key={url}
          english={english}
        />
      );
    } else if (innerItem.type === "popisy-table-1") {
      return (
        <DescriptionTableA
          data={innerItem}
          url={url}
          onParagraphClick={onParagraphClick}
          // key={url}
        />
      );
    } else if (innerItem.type === "popisy-table-2") {
      return (
        <DescriptionTableB
          data={innerItem}
          url={url}
          onParagraphClick={onParagraphClick}
          // key={url}
        />
      );
    } else if (innerItem.type === "tvary ruky") {
      return <SinglePDF pdf={pdf} />;
    } else {
      return <></>;
    }
  };

  return (
    <div className={classes.container}>
      <div className={noVideo ? classes.fullLeft : classes.left}>
        <div
          className={clsx([
            classes.containesText,
            location.pathname.startsWith("/proverejnost") &&
              classes.mainContentSection,
          ])}
        >
          {chapterContent[0].pars.length
            ? chapterContent[0].pars.map(createContent)
            : null}
        </div>
        <div className={classes.containesText}>
          {chapterContent.slice(1).map(itemToSubchapter)}
        </div>
        {chapterContent[0].references.length === 0 || noVideo ? null : (
          <div className={classes.containesText}>
            <h2>{english ? "Footnotes" : "Poznámky pod čarou"}</h2>
            {createContent(chapterContent[0].references)}
            <ol start={chapterContent[0].references[0]?.start}>
              {chapterContent[0].references.map((r: any) => (
                <ListItem
                  li={r}
                  oneVideo={false}
                  url={url}
                  noVideo={noVideo}
                  onParagraphClick={onParagraphClick}
                />
              ))}
            </ol>
          </div>
        )}
      </div>
      {url && (
        <div className={classes.right}>
          <div className={classes.playerWrapper}>
            <YoutubePlayer
              muted
              playing={playing}
              setPlaying={setPlaying}
              controls
              url={url}
              responsive
            />
            <div className={classes.playerButtons}>
              <button
                onClick={() =>
                  previousVideo(urlIndex, url, urlArray, setUrlIndex)
                }
              >
                <FontAwesomeIcon icon={faArrowLeft} />
              </button>
              <button
                onClick={() => nextVideo(urlIndex, url, urlArray, setUrlIndex)}
              >
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoTextContainer;
